export default {
  filter: {
    timeBucket: 'Granularita',
  },
  stackedPolarChart: {
    title: 'Produktivita (polárny)',
  },
  clusteredStackedBarChart: {
    title: 'Produktivita (zhlukovaný stĺpec)',
    hint: 'Kvôli časovému filtra je tento časový interval reprezentovaný len čiastočne. Umiestnite kurzor na graf pre viac podrobností.',
  },
  table: {
    title: 'Produktivita (tabuľka)',
  },
  stackedBarChart: {
    title: 'Produktivita (hromadený stĺpec)',
  },
  paretoChart: {
    title: 'Produktivita (Pareto)',
  },
  visualisationModal: {
    title: 'Nastavenia zobrazenia',
    subtitle: 'Z nasledujúcich zoznamov vyberte grafy, ktoré chcete zobraziť na paneli.',
    aggregationTitle: 'Agregácia',
    aggregationDescription: 'Tieto grafy zobrazujú výkon za celé zvolené časové obdobie',
  },
};
